import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Mail, Twitter, Instagram, X, CalendarCheck } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface ContactPopupProps {
  isOpen: boolean;
  onClose: () => void;
}

const ContactPopup: React.FC<ContactPopupProps> = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  const handleBookConsultation = () => {
    onClose();
    navigate('/contact');
  };

  const contacts = [
    { icon: Mail, label: 'Email', value: 'joseph.c@terranexusai.com' },
    { icon: Mail, label: 'Email', value: 'kacey.d@terranexusai.com' },
    { icon: Mail, label: 'Email', value: 'cole.h@terranexusai.com' },
    { icon: Twitter, label: 'X', value: '@terranexusai', url: 'https://x.com/terranexusai' },
    { icon: Instagram, label: 'Instagram', value: '@terranexusai', url: 'https://www.instagram.com/terranexusai/' },
  ];

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50"
            onClick={onClose}
          />
          <motion.div
            initial={{ opacity: 0, scale: 0.95, y: -20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: -20 }}
            className="fixed top-24 right-8 z-50 w-full max-w-sm"
          >
            <div className="bg-black/90 border border-gold-500/20 rounded-2xl p-6 shadow-xl backdrop-blur-sm">
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-xl font-bold text-gold-400">Contact Us</h2>
                <button
                  onClick={onClose}
                  className="text-gold-200 hover:text-gold-400 transition-colors"
                >
                  <X className="w-5 h-5" />
                </button>
              </div>
              <div className="space-y-3">
                {contacts.map(({ icon: Icon, label, value, url }) => (
                  <motion.a
                    key={value}
                    href={url || (label === 'Email' ? `mailto:${value}` : `https://${label.toLowerCase()}.com/${value}`)}
                    target={url ? '_blank' : undefined}
                    rel={url ? 'noopener noreferrer' : undefined}
                    className="flex items-center gap-4 p-3 rounded-lg bg-gold-500/5 hover:bg-gold-500/10 transition-colors cursor-pointer group"
                    whileHover={{ x: 8 }}
                  >
                    <Icon className="w-5 h-5 text-gold-400" />
                    <div>
                      <p className="font-medium text-gold-200">{label}</p>
                      <p className="text-sm text-gold-400 group-hover:text-gold-300 transition-colors">
                        {value}
                      </p>
                    </div>
                  </motion.a>
                ))}
              </div>
              <motion.button
                onClick={handleBookConsultation}
                className="w-full flex items-center justify-center gap-2 mt-5 px-4 py-3 rounded-lg gold-gradient-btn text-black font-semibold transition-colors"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                <CalendarCheck className="w-5 h-5" />
                Book Consultation
              </motion.button>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default ContactPopup;